export enum WalletDetailEnum {
    None = 0,
    Gcash = 1,
    Paymaya = 2,
    Paymongo = 3,
    Paypal = 4,
    WeChatPay = 5
}
